/**
 * Delegated handler: CTA buttons with data-core-button-action="play-section-video"
 * find the first playable media in the same .shopify-section and play + fullscreen.
 */
const INIT = '__shopifyCoreButtonPlaySectionVideoInit';
if (!window[INIT]) {
  window[INIT] = true;

  /**
   * @param {Element} el
   * @returns {Element | null}
   */
  function findSectionRoot(el) {
    return el.closest('.shopify-section') || el.closest('[id^="shopify-section"]');
  }

  /**
   * @param {Element} section
   * @returns {HTMLVideoElement | HTMLIFrameElement | null}
   */
  function findPlayableInSection(section) {
    const cv = section.querySelector('custom-video video');
    if (cv) return cv;
    const dm = section.querySelector('deferred-media');
    if (!dm) return null;
    const v = dm.querySelector('video');
    if (v) return v;
    const iframe = dm.querySelector('iframe.js-youtube, iframe.js-vimeo, iframe');
    return iframe || null;
  }

  /**
   * @param {HTMLVideoElement | HTMLIFrameElement} el
   */
  function requestFullscreenOn(el) {
    if (el.tagName === 'VIDEO') {
      const v = /** @type {HTMLVideoElement & { webkitEnterFullscreen?: () => void }} */ (el);
      if (typeof v.webkitEnterFullscreen === 'function') {
        try {
          v.webkitEnterFullscreen();
          return;
        } catch (_) {
          /* continue to standard API */
        }
      }
    }
    const anyEl = /** @type {Element & { requestFullscreen?: () => Promise<void>; webkitRequestFullscreen?: () => void }} */ (
      el
    );
    if (anyEl.requestFullscreen) {
      anyEl.requestFullscreen().catch(() => {});
    } else if (anyEl.webkitRequestFullscreen) {
      anyEl.webkitRequestFullscreen();
    }
  }

  /**
   * Ensure deferred-media has loaded its template; returns video or iframe when present.
   * @param {Element} section
   * @returns {Promise<HTMLVideoElement | HTMLIFrameElement | null>}
   */
  function ensureDeferredMediaReady(section) {
    const dm = section.querySelector('deferred-media');
    if (!dm) return Promise.resolve(null);
    const existing = dm.querySelector('video, iframe');
    if (existing) return Promise.resolve(/** @type {HTMLVideoElement | HTMLIFrameElement} */ (existing));

    const poster = dm.querySelector('button[id^="Deferred-Poster-Modal"]');
    if (!poster) return Promise.resolve(null);

    poster.click();

    return new Promise((resolve) => {
      const done = () => {
        const node = dm.querySelector('video, iframe');
        resolve(node ? /** @type {HTMLVideoElement | HTMLIFrameElement} */ (node) : null);
      };
      const mo = new MutationObserver(() => {
        if (dm.querySelector('video, iframe')) {
          mo.disconnect();
          clearTimeout(timeoutId);
          done();
        }
      });
      mo.observe(dm, { childList: true, subtree: true });
      const timeoutId = setTimeout(() => {
        mo.disconnect();
        done();
      }, 2500);
    });
  }

  document.addEventListener(
    'click',
    async (e) => {
      const btn = e.target.closest('[data-core-button-action="play-section-video"]');
      if (!btn) return;

      e.preventDefault();

      const section = findSectionRoot(btn);
      if (!section) return;

      let media = findPlayableInSection(section);
      if (!media) {
        media = await ensureDeferredMediaReady(section);
      }
      if (!media) return;

      try {
        if (media.tagName === 'VIDEO') {
          const video = /** @type {HTMLVideoElement} */ (media);
          video.muted = false;
          await video.play();
        }
        requestFullscreenOn(media);
      } catch (_) {
        try {
          if (media.tagName === 'VIDEO') {
            await /** @type {HTMLVideoElement} */ (media).play();
          }
        } catch (_) {
          /* ignore */
        }
      }
    },
    true
  );
}
